<script>
export default {
    name: 'InstructionSlideItem',
    props: ['item']
}
</script>

<style scoped>
    .main-wrap{
        height: 100vh;
        position: relative;
    }
    .order{
        left: 0;
        top: 0;
        position: absolute;
    }
    .order h2{
        color: #fff;
    }
    .wrap{
        max-width: 80vw;
    }
    .content{
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100vh
    }
    .content h1{
        color: #F2711C;
    }
</style>

<template>
    <div class="main-wrap">
         <div class="order">
            <h2>{{item.order}}</h2>
        </div>
        <div class="content">
            <div class="wrap">
                <h1>{{item.instruction}}</h1>
            </div>
        </div>
    </div>
</template>